import { logger } from '../../../../../../datadog/logger';
import { JotaiStore } from '../../../../../../state/types';
import { decimalToFraction } from '../../../../../../utils';
import { remoteVideoMetadataAtomFamily } from '../../../../../core/room/participant/media/atoms';
import { MAX_ASPECT_RATIO, MIN_ASPECT_RATIO } from '../../../../../core/room/participant/media/constants';
import type { VideoAspectRatioChangedPayload } from '../../mapping';

export function handleVideoAspectRatioChanged(
  { aspectRatio, userId }: VideoAspectRatioChangedPayload,
  {
    jotaiStore,
  }: {
    jotaiStore: JotaiStore;
  },
) {
  logger.info(`[ZoomVideoSDKAdapter] Received an aspect ratio change`, {
    remoteParticipantSid: userId,
    aspectRatio,
  });

  // Inverted so that NaN is rejected too
  const isWithinBounds = aspectRatio >= MIN_ASPECT_RATIO && aspectRatio <= MAX_ASPECT_RATIO;
  if (!isWithinBounds) {
    logger.warn(`[ZoomVideoSDKAdapter] Received an out-of-range aspect ratio`, {
      remoteParticipantSid: userId,
      aspectRatio,
    });
    return;
  }

  const [width, height] = decimalToFraction(aspectRatio);
  jotaiStore.set(remoteVideoMetadataAtomFamily(`${userId}`), {
    aspectRatio: { width, height },
  });
}
